module.exports = __webpack_public_path__ + "img/202107.57fa7fbe.png";